import { EventMessage, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React, { ReactNode, useEffect, useState } from "react";

import { msalInstance } from "./client";
import { loginRequest } from "./config";

type AuthProviderProps = {
  children: ReactNode;
};

function AuthProvider({ children }: AuthProviderProps): JSX.Element | null {
  const [authInitialized, setAuthInitialized] = useState<boolean>(false);

  useEffect(() => {
    async function init() {
      await msalInstance.initialize();
      await msalInstance.handleRedirectPromise();
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        await msalInstance.loginRedirect();
      } else {
        try {
          const token = await msalInstance.acquireTokenSilent(loginRequest);
          localStorage.setItem("token", token.accessToken);
        } catch {
          msalInstance.acquireTokenRedirect(loginRequest);
        }
      }
      setAuthInitialized(true);
    }
    init();
  }, []);

  useEffect(() => {
    const callbackId = msalInstance.addEventCallback(
      async (message: EventMessage) => {
        if (message.eventType === EventType.HANDLE_REDIRECT_END) {
          const account = msalInstance.getAllAccounts()[0];
          msalInstance.setActiveAccount(account);

          const token = await msalInstance.acquireTokenSilent(loginRequest);
          localStorage.setItem("token", token.accessToken);
        }
      }
    );
    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, []);

  if (!authInitialized) return null;

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}

export default AuthProvider;
